module.exports = __webpack_public_path__ + "static/media/cosmeticCase.33441082.svg";